export default "__VITE_ASSET__8a07a294__"